import { render, staticRenderFns } from "./ViewTickets.vue?vue&type=template&id=2b23acaa&scoped=true&name=tickets"
import script from "./ViewTickets.vue?vue&type=script&lang=js"
export * from "./ViewTickets.vue?vue&type=script&lang=js"
import style0 from "./ViewTickets.vue?vue&type=style&index=0&id=2b23acaa&prod&lang=scss"
import style1 from "./ViewTickets.vue?vue&type=style&index=1&id=2b23acaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23acaa",
  null
  
)

export default component.exports